import type { PlanFeature, PlanTier } from '@/types/plan-access';
import type { User } from '@/types/user';
import { isBillingExempt } from '@/utils/provider-subscription-access';

/**
 * Lê o nível de acesso que a API mandou em `providerProfile.planAccess`. A
 * regra mora na API; aqui só decide se o app avisa ANTES de tentar.
 *
 * Profissional de equipe nunca é travado pelo app: quem assina é o dono, e a
 * trava real (pelo plano do dono) volta da API como `PLAN_FEATURE_LOCKED`.
 * Sem `planAccess` (API antiga, cliente) também não trava — a API decide.
 */
export function planTierOf(user: User | null | undefined): PlanTier | null {
  if (isBillingExempt(user)) return null;
  return user?.providerProfile?.planAccess?.tier ?? null;
}

export function isPlanFeatureLocked(
  user: User | null | undefined,
  feature: PlanFeature,
): boolean {
  if (isBillingExempt(user)) return false;
  const access = user?.providerProfile?.planAccess;
  if (!access) return false;
  return access.features[feature] === false;
}

/** Código da trava na API; o `feature` diz qual aviso abrir. */
export function parsePlanFeatureLocked(err: unknown): PlanFeature | null {
  const data = (err as { response?: { data?: any } })?.response?.data;
  if (!data) return null;
  const payload = typeof data.message === 'object' ? data.message : data;
  return payload?.code === 'PLAN_FEATURE_LOCKED' && typeof payload.feature === 'string'
    ? (payload.feature as PlanFeature)
    : null;
}
